import gql from 'graphql-tag';

import { printProductSizeServiceDetails } from '../../../../graphql/fragments/print-product';

const printProductDetails = gql`
  fragment printProductDetails on PrintProduct {
    id
    name
    is_standard
    print_partner {
      id
      name
    }
    sizes {
      total
      records {
        id
        print_size {
          id
          name
          width
          height
        }
        price {
          value
          currency
        }
        min_price {
          value
          currency
        }
        total_price {
          value
          currency
        }
        mounts {
          total
        }
        orientations
        services {
          total
          records {
            ...printProductSizeServiceDetails
          }
        }
      }
    }
    print_size {
      id
      name
      width
      height
    }
  }
  ${printProductSizeServiceDetails}
`;

export default printProductDetails;
